import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  subtitle?: string;
  title: string;
  tag?: 'h1' | 'h2';
  className?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}

export function Heading({ subtitle, title, className, tag = 'h2' }: HeadingProps) {
  const Title = title?.trim() ? tag : 'div';
  return (
    <div className={cn('flex flex-col gap-2', className?.container)}>
      <p
        aria-hidden={!subtitle || undefined}
        className={cn('text-sm uppercase leading-[1.3] text-muted-foreground', className?.subtitle)}
      >
        {subtitle || '\u00a0'}
      </p>
      <Title
        data-ea-visual-tag={Title === 'h1' ? 'h2' : undefined}
        className={cn(
          'text-[32px] font-medium leading-[1.2] tracking-tighter sm:text-4xl sm:leading-[1.2] lg:text-5xl lg:leading-[1.2]',
          className?.title,
        )}
      >
        {title}
      </Title>
    </div>
  );
}
